<template>
    <div class="app-date-range-picker d-flex flex-wrap align-center">
        <app-date-picker
            :value="startDate"
            :label="startLabel"
            :outlined="outlined"
            :dense="dense"
            :hide-details="true"
            :input-class="pickerClass"
            :max="endDate || undefined"
            class="mr-1"
            @input="onStartInput"
        />
        <span class="date-sep mx-1">~</span>
        <app-date-picker
            :value="endDate"
            :label="endLabel"
            :outlined="outlined"
            :dense="dense"
            :hide-details="true"
            :input-class="pickerClass"
            :min="startDate || undefined"
            class="mr-1"
            @input="onEndInput"
        />
        <template v-if="showShortcuts">
            <v-btn
                v-for="sc in shortcuts"
                :key="sc.type"
                :color="sc.type === 'reset' ? 'grey darken-1' : 'grey darken-2'"
                outlined
                small
                elevation="0"
                class="mr-1"
                @click="$emit('shortcut', sc.type)"
            >{{ sc.label }}</v-btn>
        </template>
    </div>
</template>

<script>
export default {
    name: 'AppDateRangePicker',
    props: {
        startDate:     { type: String,  default: '' },
        endDate:       { type: String,  default: '' },
        startLabel:    { type: String,  default: '시작일' },
        endLabel:      { type: String,  default: '종료일' },
        showShortcuts: { type: Boolean, default: true },
        outlined:      { type: Boolean, default: true },
        dense:         { type: Boolean, default: false },
        pickerClass:   { type: String,  default: '' },
        shortcuts: {
            type: Array,
            default: () => [
                { label: '오늘',   type: 'today'   },
                { label: '1주일',  type: '1week'   },
                { label: '1개월',  type: '1month'  },
                { label: '3개월',  type: '3month'  },
                { label: '6개월',  type: '6month'  },
                { label: '초기화', type: 'reset'   },
            ],
        },
    },
    methods: {
        onStartInput(val) {
            this.$emit('update:startDate', val);
            this.$emit('change-start', val);
        },
        onEndInput(val) {
            this.$emit('update:endDate', val);
            this.$emit('change-end', val);
        },
    },
};
</script>
